import GoodsApi from "@/Api/GoodsApi";
import EditTableCheck from "@/Common/Table/EditTableCheck";
import { numProps, strProps } from "@/Common/Table/column";
import { ColumnType } from "@/Common/Table/type";
import { Goods } from "@/Models/Tables/Goods";
import { ViewGoods } from "@/Models/Views/ViewGoods";
import { Fragment, useCallback, useMemo, useState } from "react";
import Add from "./Add";
import { getUploadFlagNames } from "@Models/Enums/UploadFlag";
import { Button, message, Upload, UploadProps } from "antd";
import axios from "axios";
import {
    UploadOutlined,
    ArrowDownOutlined
} from "@ant-design/icons";
function getColumns(): ColumnType<ViewGoods>[] {
    return [
        numProps("id", "Id", 60, true),
        strProps("typeName", "类别", 120, true, true),
        strProps("name", "物品名称", 160, true, true),
        strProps("code", "物品编码", 120, true, true),

        strProps("standard", "规格", 150, true, true),
        // numProps("robotNo", "视觉码", 80, false),
        strProps("unit", "单位", 60, false, false),
        numProps("price", "单价", 80, true, s => s.toFixed(2)),
        strProps("areaName", "所属区域", 120, true, true),
        numProps("stockQuantity", "库存数量", 100, true),
        numProps("stockHigh", "最高库存", 100, true),
        numProps("stockLow", "最低库存", 100, true),
        numProps("validityDay", "保质期(天)", 110, true),
        numProps("alarmDay", "提前报警(天)", 120, true),
        strProps("uploadFlag", "上传状态", 80, true, true, getUploadFlagNames),
        strProps("remark", "备注", 80, true, true),
        // strProps("erpCategory1", "第一类", 80, true, true),
        strProps("erpCategory2", "第二类", 100, true, true),
        strProps("erpCategory3", "第三类", 100, true, true),
        strProps("erpCode", "ERP编码", 120, true, true),
        strProps("erpGoodsName", "ERP名称", 130, true, true),
        strProps("erpGoodsStandard", "ERP规格", 130, true, true),
        strProps("erpBrand", "ERP品牌", 120, true, true),
        strProps("erpUnit", "ERP单位", 120, true, true),
        strProps("erpAttribute", "ERP属性", 120, true, true),

    ];
}
export default Index;
function Index() {
    const columns = useMemo(getColumns, []);
    const [msg, setMsg] = useState<string>("");
    const [msg2, setMsg2] = useState<string>("");

    const onDownloadTemplate = useCallback(() => {
        window.open(
            "http://" +
            window.location.hostname +
            ":" +
            window.location.port +
            "/ExportExcel/WMS对接ERP编码批量修改模板示例.xlsx"
        );
    }, []);
        const onDownloadTemplate2 = useCallback(() => {
        window.open(
            "http://" +
            window.location.hostname +
            ":" +
            window.location.port +
            "/ExportExcel/物料编码分类模板.xlsx"
        );
    }, []);
    const props: UploadProps = {
        name: "file",
        action: "/api/Goods/UpGoodsErpCode",
        headers: {
            authorization: axios.defaults.headers.common["Authorization"] ? axios.defaults.headers.common["Authorization"].toString() : '',
        },
        onChange(info) {
            console.log("info:" + JSON.stringify(info));
            if (info.file.status === "done") {
                if (info.file.response.length > 0) {
                    setMsg(info.file.response); setMsg2('');
                }
            } else if (info.file.status === "error") {
                message.error(`${info.file.name}上传失败:${info.file.response}`);
            }
        },
    };
    const props2: UploadProps = {
        name: "file",
        action: "/api/Goods/UpGoodsByErp",
        headers: {
            authorization: axios.defaults.headers.common["Authorization"] ? axios.defaults.headers.common["Authorization"].toString() : '',
        },
        onChange(info) {
            console.log("info:" + JSON.stringify(info));
            if (info.file.status === "done") {
                if (info.file.response.length > 0) {
                    setMsg2(info.file.response); setMsg('');
                }
            } else if (info.file.status === "error") {
                message.error(`${info.file.name}上传失败:${info.file.response}`);
            }
        },
    };
    return <Fragment><EditTableCheck< Goods, ViewGoods> getData={GoodsApi.getViews}
        baseColumns={columns}
        isRank
        AddDom={Add}
        updDataHandle={GoodsApi.upd}
        delDataHandle={(s: { id: number; }) => GoodsApi.del(s.id)}
        updMerge={updMerge}
        addDataHandle={GoodsApi.add}
        editCheck={(s: { id: number; }) => s.id === 1}
        rowKey={"id"}
    />

        <div style={{ position: "relative" }}>
            <div
                style={{ position: "absolute", left: 80, top: -35, width: 400 }}
            >
                <Button type="link">ERPCode导入:</Button>
                <Upload {...props}>
                    <Button icon={<UploadOutlined />}>导入Excel格式文件</Button>
                </Upload>
                <Button
                    icon={<ArrowDownOutlined />}
                    style={{ position: "absolute", left: 290, top: -0 }}
                    onClick={onDownloadTemplate}
                >
                    下载模板
                </Button> <div
                    style={{
                        display: msg ? "inline" : "none",
                        width: 500,
                        color: "red",
                    }}
                >
                    {msg}
                </div>

            </div>    <div
                style={{ position: "absolute", left: 480, top: -35, width: 400 }}
            >
                <Button type="link">ERP信息导入:</Button>
                <Upload {...props2}>
                    <Button icon={<UploadOutlined />}>导入Excel格式文件</Button>
                </Upload>
                <Button
                    icon={<ArrowDownOutlined />}
                    style={{ position: "absolute", left: 290, top: -0 }}
                    onClick={onDownloadTemplate2}
                >
                    下载模板
                </Button> <div
                    style={{
                        display: msg2 ? "inline" : "none",
                        width: 500,
                        color: "red",
                    }}
                >
                    {msg2}
                </div>

            </div> </div></Fragment>
}

function updMerge(source: ViewGoods, target: Goods) {
    target.id = source.id;
    return target;
}